import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {DVIR, DVIREntity} from "../../../model/dvir";

export interface DVIRSelectorProps {

}

export const dvirsSelector = () => createSelector(
  [getUseQueryResultData<DVIR[]>],
  (data) => {
    return selectDVIRsAndTransform(
      data ?? [], {}
    );
  }
);

export const dvirSelector = () => createSelector(
  [getUseQueryResultData<DVIR>],
  (data) => {
    return data ? transformDVIR(data) : undefined;
  }
);

export const selectDVIRs = (values?: DVIR[], selector?: DVIRSelectorProps): DVIR[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformDVIR = (value: DVIR): DVIREntity => {
  return DVIREntity.from(value)
}

export const selectDVIRsAndTransform = (values?: DVIR[], selector?: DVIRSelectorProps): DVIREntity[] => {
  const selected = selectDVIRs(values, selector);
  return selected.map(transformDVIR);
};
